'use client';
import React, { useEffect } from 'react';
import { User } from '@supabase/supabase-js';
import RoadMapPanelHeader from '../graph/RoadMapPanelHeader';

type SideNavProps = {
  user: User | null;
  setShowLoadingContent: (showLoadingContent: boolean) => void;
  graphID: string;
  children: React.ReactNode;
};

const SidebarContent: React.FC<SideNavProps> = ({
  user,
  setShowLoadingContent,
  graphID,
  children,
}) => {
  return (
    <nav className="flex flex-col content-between justify-start flex-1 h-full pt-4 top ">
      <div className="pt-0 @mobile/sidebar:pt-2  pb-0.5 px-4 @mobile/sidebar:px-6">
        <RoadMapPanelHeader user={user} />
      </div>
      <div className="w-full grow ">
        {/* <RoadMapPanelBody setShowLoadingContent={setShowLoadingContent} /> */}

        {children}
      </div>

      {/* <RoadMapPanelFooter user={user} /> */}
    </nav>
  );
};

export default SidebarContent;
